import React from 'react';
import { ClipboardList, AlertCircle, ExternalLink, CheckCircle } from 'lucide-react';
export function HowToAddCEClasses() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-780">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-781">
        {/* Page Header */}
        <div className="mb-12" data-id="element-782">
          <div className="flex items-center justify-center mb-6" data-id="element-783">
            <ClipboardList className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-784" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-785">
              How To Add CE Classes
            </h1>
          </div>
        </div>

        {/* Main Instructions */}
        <div className="mb-12" data-id="element-786">
          <div className="bg-brand-purple-50 rounded-lg p-8 border-2 border-brand-purple-200 mb-8" data-id="element-787">
            <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-788">
              HOW TO ADD CE CLASSES AND RENEW YOUR LICENSE ONLINE
            </h2>
            <p className="text-base text-gray-700 font-semibold" data-id="element-789">
              *Add your current CE classes before proceeding to pay and renew
              your license.
            </p>
          </div>

          {/* Step-by-Step Instructions */}
          <div className="space-y-6" data-id="element-790">
            {/* Step 1 */}
            <div className="bg-white rounded-lg border-2 border-gray-200 p-6" data-id="element-791">
              <div className="flex items-start mb-4" data-id="element-792">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-793">
                  1
                </div>
                <div className="flex-1" data-id="element-794">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-795">
                    Click this link to log into your account at ADRE:{' '}
                    <a href="https://ptl.az.gov/dre/#/login" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline inline-flex items-center" data-id="element-796">
                      https://ptl.az.gov/dre/#/login
                      <ExternalLink className="w-4 h-4 ml-1" data-id="element-797" />
                    </a>
                  </p>
                  <p className="text-sm text-gray-600 mt-2 italic" data-id="element-798">
                    (Your license number is required to log in. If you do not
                    have it,{' '}
                    <a href="https://services.azre.gov/PdbWeb/IndividualLicense/SearchIndividualLicenses" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-799">
                      click HERE
                    </a>{' '}
                    to obtain your license number)
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-white rounded-lg border-2 border-gray-200 p-6" data-id="element-800">
              <div className="flex items-start mb-4" data-id="element-801">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-802">
                  2
                </div>
                <div className="flex-1" data-id="element-803">
                  <p className="text-base text-gray-700 leading-relaxed mb-3" data-id="element-804">
                    After logging in, under Quick Links (Personal) list, click
                    on <strong data-id="element-805">Manage My Continuing Education</strong>. On the
                    upper left side, find the box and click on{' '}
                    <strong data-id="element-806">Continuing Education</strong> and then{' '}
                    <strong data-id="element-807">Submit Courses</strong>.
                  </p>
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-808">
                    On your certificate, find and enter the course number. Use
                    the date on your certificate for Date Started and Date
                    Finished.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-white rounded-lg border-2 border-gray-200 p-6" data-id="element-809">
              <div className="flex items-start mb-4" data-id="element-810">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-811">
                  3
                </div>
                <div className="flex-1" data-id="element-812">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-813">
                    Once your courses are all succesfully recorded, click the
                    blue <strong data-id="element-814">Return Home</strong> button. Under Quick Links
                    (Personal) list, find and click{' '}
                    <strong data-id="element-815">Renew My License</strong>. Follow all the prompts,
                    answer YES/NO questionanaire and then pay your license
                    renewal fee.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-white rounded-lg border-2 border-gray-200 p-6" data-id="element-816">
              <div className="flex items-start mb-4" data-id="element-817">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-818">
                  4
                </div>
                <div className="flex-1" data-id="element-819">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-820">
                    After paying for your new license, print a copy of the
                    confirmation for your records (you may need to provide this
                    confirmation to your broker). Once you renew your license,
                    you and/or your broker may print your license online at the
                    ADRE website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="space-y-6 mb-12" data-id="element-821">
          {/* Important Warning */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-822">
            <div className="flex items-start" data-id="element-823">
              <AlertCircle className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-824" />
              <p className="text-base text-gray-800" data-id="element-825">
                <strong data-id="element-826">
                  **We suggest that you add your classes directly to ADRE's
                  website.
                </strong>{' '}
                If you send copies of your certificates to ADRE, they can charge
                you an additional $50.00
              </p>
            </div>
          </div>

          {/* In-Person Assistance */}
          <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg" data-id="element-827">
            <div className="flex items-start" data-id="element-828">
              <AlertCircle className="w-6 h-6 text-red-600 mr-3 mt-1 flex-shrink-0" data-id="element-829" />
              <p className="text-base text-gray-800" data-id="element-830">
                In the event you are unable to renew online, as of August 30,
                2024, ADRE has moved to appointment-only for in-person
                assistance. If you would like in-person assistance, please reach
                out using their{' '}
                <a href="https://azre.gov/contact-us/message-center" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-831">
                  Message Center
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Help CTA */}
        <div className="bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-832">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-833">
            Need Help Adding Your Classes?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-834">
            Our support team is available to assist you with any questions about
            adding your CE classes or renewing your license.
          </p>
          <a href="/Contact" className="inline-flex items-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-835">
            Contact Support
          </a>
        </div>
      </div>
    </div>;
}